import React, { useState } from 'react'
import { findCenter } from './map.utils'
import AdboardMap from '../PageHome/AdboardMap'
import { getTypeBasedOnAspectRatio } from '@/lib/utils'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { AdboardFragment } from './types';

export default function ScreenLocationBox({
  listingDetails
}:{
    listingDetails:AdboardFragment
}) {
    
  const [highlight,setHighlight] = useState("")
  if (!listingDetails) return null;
  let center = findCenter(listingDetails.players.map(item=>item.map))
  if(isNaN(center.lat) || isNaN(center.lng)){
    center = {
      lat:28.4226011,
      lng:76.9900807
    }
  }

  return (
    <div className="listingSection__wrap">
      {/* HEADING */}
      <div>
        <h2 className="text-2xl font-semibold">Screen location</h2>
        <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
                This adboard has {listingDetails.players.length||0} screen(s).
        </span>
      </div>
      <div className="grid grid-cols-2 gap-2">
        {/* MAP */}
        <div className="aspect-w-5 aspect-h-5 sm:aspect-h-3">
          <div className="rounded-xl overflow-hidden">
            <AdboardMap
              highlightedKeys={highlight ? [highlight]:[]}
              pois={listingDetails.players.map((item)=>{
                return {
                  key: item.id,
                  location: { lat: item.map?.lat||0, lng: item.map?.lng||0 }
                }
              })}></AdboardMap>
          </div>
        </div>
        <Table className=''>
          <TableHeader>
            <TableRow>
              <TableHead>Screen name</TableHead>
              <TableHead>Aspect ratio</TableHead>
              <TableHead>Size(in ft)</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody className=''>
            {[...listingDetails.players]
              .sort((a,b)=>{
                return ( b.screenSize?.width||0)*(b.screenSize?.height||0) - ( a.screenSize?.width||0)*(a.screenSize?.height||0)
              }).map((item,i)=>{
                const aspectRatio = ((item.resolution?.width||0)/(item.resolution?.height||1)).toFixed(2)
                return (  
                  <TableRow key={item.name} onMouseOver={()=>setHighlight(item.id)}
                    onMouseLeave={()=>setHighlight("")}
                    className='cursor-pointer'
                  >
                    <TableCell>Screen {i+1}</TableCell>
                    <TableCell>{aspectRatio}:1 [{getTypeBasedOnAspectRatio(aspectRatio)}]</TableCell>
                    <TableCell className="whitespace-nowrap">{item.screenSize?.width} x {item.screenSize?.height} ft</TableCell>
                  </TableRow>
                )})}
          </TableBody>
        </Table>
             
      </div>
    </div>
  );
}

